/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierServicePair } from "./CarrierServicePair";
import {
  CarrierServicePairFromJSON,
  CarrierServicePairFromJSONTyped,
  CarrierServicePairToJSON,
  CarrierServicePairToJSONTyped,
} from "./CarrierServicePair";

/**
 *
 * @export
 * @interface CreatePricingAgreementsRequest
 */
export interface CreatePricingAgreementsRequest {
  /**
   *
   * @type {string}
   * @memberof CreatePricingAgreementsRequest
   */
  companyId: string;
  /**
   *
   * @type {Array<CarrierServicePair>}
   * @memberof CreatePricingAgreementsRequest
   */
  carriers: Array<CarrierServicePair>;
}

/**
 * Check if a given object implements the CreatePricingAgreementsRequest interface.
 */
export function instanceOfCreatePricingAgreementsRequest(
  value: object,
): value is CreatePricingAgreementsRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("carriers" in value) || value["carriers"] === undefined) return false;
  return true;
}

export function CreatePricingAgreementsRequestFromJSON(
  json: any,
): CreatePricingAgreementsRequest {
  return CreatePricingAgreementsRequestFromJSONTyped(json, false);
}

export function CreatePricingAgreementsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreatePricingAgreementsRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    carriers: (json["carriers"] as Array<any>).map(CarrierServicePairFromJSON),
  };
}

export function CreatePricingAgreementsRequestToJSON(
  json: any,
): CreatePricingAgreementsRequest {
  return CreatePricingAgreementsRequestToJSONTyped(json, false);
}

export function CreatePricingAgreementsRequestToJSONTyped(
  value?: CreatePricingAgreementsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    carriers: (value["carriers"] as Array<any>).map(CarrierServicePairToJSON),
  };
}
